<template>
  <!-- Android CompletedJobsFragment (opened with a booking id): "Job History" = the consumer's completed bookings.
       Picking one opens that job like Android (JobLandingFragment with the history buttons disabled). -->
  <div ref="modal" class="modal fade fxModal" tabindex="-1" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered modal-dialog-scrollable" style="max-width: 520px">
      <div class="modal-content">
        <div class="modal-body p-[20px] font-roboto">
          <FxModalHeader title="Job History" :dismiss="false" @close="close" />
          <div class="mt-[15px] flex flex-col gap-[10px]">
            <!-- real <a href> (open in new tab); a plain click also closes the modal -->
            <router-link v-for="item in items" :key="item.id" :to="jobRoute(item.id)"
              class="block w-full text-left no-underline text-inherit px-[15px] py-[12px] rounded-[10px] border-1 border-[#EFEFEF] bg-[#fff] hover:bg-[#F4F5FB] transition"
              @click="onJobClick">
              <!-- {{ item }} -->
              <span class="flex items-center justify-between gap-2">
                <span class="text-[15px] font-medium text-[#333333]">Booking ID: {{ item.id }}</span>
                <span v-if="item.status_text"
                  class="text-[12px] font-medium py-[2px] px-[10px] rounded-[5px] text-white"
                  :style="{ backgroundColor: $helper.sarStatusColor(item.status_text) }">{{
                    $helper.formatStatus(item.status_text) }}</span>
              </span>
              <span class="block mt-[4px] text-[13px] text-[#666666]">
                Job Type: {{ item.services?.[0]?.title || '-' }}
              </span>
              <span v-if="item.consumer_name" class="block mt-[4px] text-[13px] text-[#666666]">
                Consumer Name: {{ item.consumer_name || '-' }}
              </span>
              <span class="block mt-[4px] text-[13px] text-[#666666]">
                Date: <template v-if="item.booking_date"> {{ item.booking_date
                }}</template>
              </span>
              <span v-if="item.technician_name" class="block mt-[2px] text-[13px] text-[#666666]">Technician: {{
                item.technician_name }}</span>
            </router-link>
            <p v-if="loaded && !items.length" class="m-0 py-[25px] text-center text-[15px] text-[#333333]">
              {{ emptyText || 'No Old Bookings Found' }}
            </p>
            <button v-if="page < totalPages" type="button" class="fxBtnSecondary self-center" :disabled="busy"
              @click="load(page + 1)">Load More</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Modal } from "bootstrap";
import { isNewTabClick } from "@/helpers/newTabClick";
import FxModalHeader from "../nest_components/FxModalHeader.vue";
import { bookingActionsApi } from "../../services/bookingActionsApi";

export default {
  components: { FxModalHeader },
  props: {
    bookingId: { type: [String, Number], required: true },
  },
  emits: ["failed"],
  data() {
    return { items: [], page: 1, totalPages: 1, loaded: false, busy: false, emptyText: "" };
  },
  beforeUnmount() {
    Modal.getInstance(this.$refs.modal)?.dispose();
  },
  methods: {
    async open() {
      this.items = [];
      this.page = 1;
      this.totalPages = 1;
      this.loaded = false;
      this.emptyText = "";
      Modal.getOrCreateInstance(this.$refs.modal).show();
      await this.load(1);
    },
    async load(page) {
      this.busy = true;
      const res = await bookingActionsApi.oldBookings(this.bookingId, page);
      this.busy = false;
      this.loaded = true;
      if (!res.ok) {
        if (res.activeRecord) this.close();
        this.$emit("failed", res);
        return;
      }
      const list = Array.isArray(res.body) ? res.body : [];
      this.items = page === 1 ? list : this.items.concat(list);
      this.page = page;
      this.totalPages = Number(res.paging?.total_pages) || page;
      if (!list.length && page === 1) this.emptyText = res.message;
    },
    // Android opens the old job with the Job History / Universal Quotes buttons disabled
    jobRoute(id) {
      return { path: `/job/detail/${id}`, query: { history: 1 } };
    },
    // router-link navigates; a plain click also closes the modal (Ctrl/Cmd/middle click keeps it open)
    onJobClick(e) {
      if (!isNewTabClick(e)) this.close();
    },
    close() {
      Modal.getInstance(this.$refs.modal)?.hide();
    },
  },
};
</script>
